import PropTypes from 'prop-types'
import classnames from 'classnames'
import classes from './ToggleTabs.module.scss'

const ToggleTabs = ({ isRightSelected, setIsSelectedRight, className, buttonsText }) => {
  const handleLeftClick = () => {
    if (isRightSelected) {
      setIsSelectedRight(false)
    }
  }

  const handleRightClick = () => {
    if (!isRightSelected) {
      setIsSelectedRight(true)
    }
  }

  return (
    <div className={className}>
      <button
        className={classnames(classes.button, { [classes.selected]: !isRightSelected })}
        onClick={handleLeftClick}
      >
        {buttonsText[0]}
      </button>
      <button
        className={classnames('ml-3', classes.button, { [classes.selected]: isRightSelected })}
        onClick={handleRightClick}
      >
        {buttonsText[1]}
      </button>
    </div>
  )
}

ToggleTabs.propTypes = {
  isRightSelected: PropTypes.bool.isRequired,
  setIsSelectedRight: PropTypes.func.isRequired,
  className: PropTypes.string,
  buttonsText: PropTypes.array.isRequired,
}

export default ToggleTabs
